import React from 'react';
import { Tabs, Tab, Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { Link, Redirect } from 'react-router-dom';

import style from './agencyForm.module.scss';
import {
  AgencyFormForAgencyModel,
  AgencyFormForAgencyProps,
  AgencyFormForAgencyState
} from '../AgencyForm/AgencyFormForAgencyModel';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { DefaultAdLogoFormModel } from 'components/AdLogoForm/AdLogoFormModel';
import AdLogoForm from 'components/AdLogoForm/AdLogoForm';
import i18n from 'i18n';
import { FormikField } from 'components/common/form/field/FormikField';
import { LabelField } from 'components/common/form/field/LabelField';
import _ from 'lodash';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { addOnEnabled } from 'core/permission/PermissionDSL';
import { ADDONFEATURE } from 'core/agency/AddonFeature';
import { TitleWithBreadcrumbs } from 'components/TitleArea/TitleWithBreadcrumbs';
import { AdDeclarationForm } from 'components/AdDeclarationForm/AdDeclarationForm';
import { CollapsibleSection } from 'components/CollapsibleSection';

const adLogoValidTypes = ['image/jpeg', 'image/jpg', 'image/png'];
const adLogoHint = [
  i18n.t('creativeSetupFlow.labels.typeHint'),
  i18n.t('adLogoForm.labels.sizeHint')
];
export class AgencyFormForAgency extends React.Component<
  AgencyFormForAgencyProps,
  AgencyFormForAgencyState
> {
  model: AgencyFormForAgencyModel;
  handler: number;
  constructor(props: any) {
    super(props);
    this.model = this.props.model;
    this.state = this.model.state;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handler = this.model.event.add((model) => {
      this.setState(model.state);
    });
  }

  componentDidMount() {
    this.model.init();
  }

  componentWillUnmount() {
    this.props.model.onUnmount(this.handler);
  }

  handleSubmit(request: any) {
    this.model.save(request);
  }

  render() {
    const { cancelPath, title, defaultAgcData, validate } = this.model;
    const { isLoading, redirectUrl } = this.state;
    if (isLoading) {
      return <LoadingIndicator />;
    }

    if (redirectUrl) {
      return <Redirect to={redirectUrl} push />;
    }

    const enableAdLogo = defaultAgcData.addonFeatures.creatives.customizeAdLogo;
    const adLogoFormModel = enableAdLogo
      ? new DefaultAdLogoFormModel()
      : undefined;
    return (
      <div className={style.container}>
        <header>
          <TitleWithBreadcrumbs
            title={i18n.t(title)}
            routes={this.props.model.breadcrumbs}
          />
        </header>
        <div className={style.innerContent}>
          <Formik
            initialValues={defaultAgcData}
            enableReinitialize
            onSubmit={this.handleSubmit}
            validate={validate}
            validateOnBlur={false}
          >
            {({ values }) => {
              const { addonProps } = values;
              const hasAnyChannelExpressPassEnabled = !_.isEmpty(
                addonProps.expressPass
              );
              return (
                <Form>
                  <Tabs defaultActiveKey='basic' id='agency-detail'>
                    <Tab
                      eventKey='basic'
                      title={i18n.t('agencyDetail.labels.basicTab')}
                    >
                      <div className={style.agencyFrom}>
                        <fieldset>
                          <legend>
                            <span>
                              {i18n.t('agencyDetail.labels.basicTab')}
                            </span>
                          </legend>
                          <CollapsibleSection
                            title={i18n.t('agency.information')}
                            collapsible={false}
                          >
                            <div className={style.fieldContent}>
                              <FormikField.FileInput
                                name='logoData'
                                label={i18n.t('agency.logo')}
                                type='image'
                                validTypes={adLogoValidTypes}
                                hints={adLogoHint}
                                fitContent={false}
                                className={style.logoInput}
                              />
                            </div>
                          </CollapsibleSection>
                          <PermissionChecker
                            permissionAware={addOnEnabled(
                              ADDONFEATURE.COMPANY.AGENCY_PROFIT
                            )}
                          >
                            <CollapsibleSection
                              title={i18n.t('agency.marginSetting')}
                              collapsible={false}
                            >
                              <div className={style.fieldContent}>
                                <FormikField.InputGroup
                                  label={i18n.t('agency.agcPercent')}
                                  name='agcPercent'
                                  type='number'
                                  postfix='%'
                                />
                                <LabelField
                                  label={i18n.t(
                                    'agency.addonProps.maxOrderProfit'
                                  )}
                                  value={`${_.get(defaultAgcData, 'addonProps.maxOrderProfit', 0)}%`}
                                />
                              </div>
                            </CollapsibleSection>
                          </PermissionChecker>
                          {adLogoFormModel && (
                            <CollapsibleSection
                              title={i18n.t('adLogoForm.labels.title')}
                              collapsible={false}
                            >
                              <AdLogoForm model={adLogoFormModel} bare />
                            </CollapsibleSection>
                          )}
                        </fieldset>
                      </div>
                    </Tab>
                    {hasAnyChannelExpressPassEnabled && (
                      <Tab
                        eventKey='adDeclaration'
                        title={i18n.t('agencyDetail.labels.adDeclarationTab')}
                      >
                        <AdDeclarationForm />
                      </Tab>
                    )}
                  </Tabs>
                  <div className={style.buttonArea}>
                    <Button size='sm' type='submit'>
                      {i18n.t('common.buttons.submit')}
                    </Button>
                    <Link to={cancelPath} className='btn btn-secondary btn-sm'>
                      {i18n.t('common.buttons.cancel')}
                    </Link>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}
